import { useLocation } from 'react-router-dom'
import { Bell, HelpCircle, ChevronRight } from 'lucide-react'

const Topbar = () => {
  const location = useLocation()
  
  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname
    if (path === '/dashboard') return 'Dashboard'
    if (path.includes('/patients/search')) return 'Search Patient'
    if (path.includes('/patients/list')) return 'Patient Records'
    if (path.includes('/patients') && path.includes('/view')) return 'Patient Details'
    if (path.includes('/patients') && path.includes('/edit')) return 'Edit Patient'
    if (path.includes('/patients') && path.includes('/audit')) return 'Audit Log'
    if (path.includes('/cmo')) return 'Insurance Manager Dashboard'
    if (path.includes('/admin/users')) return 'User Management'
    if (path.includes('/admin')) return 'Insurance Admin Dashboard'
    return 'Epione Portal'
  }
  
  // Get breadcrumbs
  const getBreadcrumbs = () => {
    const path = location.pathname
    const parts = path.split('/').filter(Boolean)
    const labels = {
      cmo: 'Insurance Manager',
      admin: 'Insurance Admin',
    }
    return parts.map((part, index) => ({
      label: labels[part] || part.charAt(0).toUpperCase() + part.slice(1).replace(/-/g, ' '),
      path: '/' + parts.slice(0, index + 1).join('/')
    }))
  }
  
  const breadcrumbs = getBreadcrumbs()
  
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Page Title & Breadcrumb */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800">{getPageTitle()}</h2>
            <div className="flex items-center space-x-2 mt-1 text-sm text-gray-500">
              {breadcrumbs.map((crumb, index) => (
                <div key={crumb.path} className="flex items-center">
                  {index > 0 && <ChevronRight size={14} className="mx-1" />}
                  <span className={index === breadcrumbs.length - 1 ? 'text-blue-600 font-medium' : ''}>
                    {crumb.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
          
          {/* Actions */}
          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
              <HelpCircle size={20} />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Topbar
